import React from "react";
import { Link } from "react-router-dom";
import SignInPresenter from "./SignInPresenter";
import { signInUseCase } from "../../usecases/user";
import { Button } from "nq-component";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import InputFactory from "../../components/InputFactory";

class SignInPage extends BasePage {
  constructor() {
    super();
    this.presenter = new SignInPresenter(this, signInUseCase());
    this.state = { progress: false };
  }

  formSubmit(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  isApplicantWalkIn() {
    return this.props.params.isWalkIn;
  }

  render() {
    const master = this.props.params.master === "master";
    const isWalkIn = this.props.params.isWalkIn;
    return (
      <div className="vh-100">
        <div className="d-flex h-100">
          <div className="m-auto container-md p-3 p-lg-5 d-flex justify-content-center">
            <div className="bg-white rounded p-3 w-75 w-md-50 w-sm-100">
              <div className="col">
                <div className="">
                  <div className="h-100 d-flex align-items-center">
                    <div className="text-center p-3 w-100">
                      <img
                        className="img-fluid login-img mb-3 w-25"
                        alt="company logo"
                        src="/lgs.jpeg"
                        width="400"
                        height="400"
                      />
                    </div>
                  </div>
                </div>
                <div className="p-3 px-lg-5 py-lg-4">
                  <h2
                    className="fw-bold text-center"
                    style={{ color: "#d18237" }}
                  >
                    Login
                  </h2>
                  <p className="text-black-50 text-center mb-5">
                    Enter your details to access your account
                  </p>
                  <form className="w-100" onSubmit={this.formSubmit.bind(this)}>
                    <div className="d-flex justify-content-center">
                      <div className="row g-3 w-50">
                        <div className="col-md-12">
                          {master && (
                            <>
                              <label className="form-label fs-sm">
                                Master key
                              </label>
                              <InputFactory
                                type="Password"
                                required
                                className="form-control bg-light-subtle p-2"
                                placeholder="Master key"
                                field="masterKey"
                                onChange={this.onChange.bind(this)}
                              />
                            </>
                          )}

                          <label className="form-label fs-sm mt-3">Email</label>
                          <InputFactory
                            required
                            type="Email"
                            autoComplete="nope"
                            className="form-contro bg-light-subtle p-2"
                            placeholder="Enter your email"
                            field="username"
                            onChange={this.onChange.bind(this)}
                          />
                        </div>
                        <div className="col-md-12">
                          <label className="form-label fs-sm">Password</label>
                          <InputFactory
                            type="Password"
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Create your password"
                            field="password"
                            onChange={this.onChange.bind(this)}
                          />
                        </div>
                        <div className="text-end">
                          <div className="mb-3 text-end">
                            {/* <Link to="/forgot" className="fs-sm ms-2">
                              Forgot your password?
                            </Link> */}
                          </div>
                        </div>
                        <div className="text-center">
                          <Button
                            progress={this.state.progress}
                            style={{ backgroundColor: "#d18237" }}
                            type="submit"
                            className="btn text-white w-50 fw-bold py-2 fs-6"
                          >
                            {this.state.progress ? "Please wait..." : "Login"}
                          </Button>
                          <div className="my-2 fw-thin text-black-50">
                            Don't have an account?
                            <span>
                              <Link
                                to={`/signup/${isWalkIn}`}
                                className="ms-1 text-decoration-underline"
                                style={{ color: "#d18237" }}
                              >
                                Sign up
                              </Link>
                            </span>
                          </div>
                        </div>
                        {/* <div className="text-center">
                        <span className="fs-sm">
                          Don't have an account?
                          <Link to="/signup" className="ms-1">
                            <span className="text-decoration-underline">
                              Sign up
                            </span>
                          </Link>
                        </span>
                      </div> */}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignInPage);
